import React from "react";

import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import WPPaginaDAO from "./dataAccess/WP/WPPaginaDAO";
import WPFaqModel from "./model/WPFaqModel";
import Carregando from "./components/Carregando";
import NavegadorUtil from "./util/NavegadorUtil";
import Rodape from "./components/Rodape";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface IAjudaPaginasProps extends RouteComponentProps {}

type AjudaPaginasState = {
  busca: string;
  selecionado: string;
  carregando: boolean;
  concluido: boolean;
  faq: WPFaqModel[];
};

class AjudaPaginas extends React.Component<
  IAjudaPaginasProps,
  AjudaPaginasState
> {
  constructor(props: IAjudaPaginasProps) {
    super(props);

    this.filtrarFAQ = this.filtrarFAQ.bind(this);

    this.state = {
      busca: "",
      carregando: false,
      concluido: false,
      faq: [],
      selecionado: "",
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Ajuda");

    this.setState({ carregando: true });

    WPPaginaDAO.getInstance()
      .getFAQ()
      .then((faq: WPFaqModel[]) => {
        this.setState({ carregando: false, concluido: true, faq });
      });
  }

  filtrarFAQ(q: string): void {
    this.setState({ busca: q });
  }

  setSelecionado(i: string): void {
    this.setState({ selecionado: this.state.selecionado === i ? "" : i });
  }

  isSelecionado(i: string): any {
    return this.state.selecionado === i;
  }

  render(): any {
    const { carregando, concluido } = this.state;

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo="Ajuda"></BotaoVoltar>
        </div>
        <ul className="arrow-list">
          <li
            onClick={() =>
              NavegadorUtil.redirect(
                "/ajuda/paginas/politica-privacidade-oba",
                this.props.history
              )
            }
          >
            <div>
              Política de privacidade <br />
              Oba Hortifruti
            </div>
            <div className="more">&gt;</div>
          </li>
          <li
            onClick={() =>
              NavegadorUtil.redirect(
                "/ajuda/paginas/politica-privacidade-bem-querer",
                this.props.history
              )
            }
          >
            <div>
              Política de privacidade
              <br />
              Programa "Cliente Bem Querer”
            </div>
            <div className="more">&gt;</div>
          </li>
          <li
            onClick={() =>
              NavegadorUtil.redirect(
                "/ajuda/paginas/termos-condicoes-bem-querer",
                this.props.history
              )
            }
          >
            <div>
              Termos e condições de uso do
              <br />
              Programa "Cliente Bem Querer”
            </div>
            <div className="more">&gt;</div>
          </li>
          <li
            onClick={() =>
              NavegadorUtil.redirect(
                "/ajuda/paginas/regulamento-programa-bem-querer",
                this.props.history
              )
            }
          >
            <div>
              Regulamento do
              <br />
              Programa "Cliente Bem Querer”
            </div>
            <div className="more">&gt;</div>
          </li>
        </ul>
        <Carregando exibir={carregando} concluido={concluido} />
        <Rodape parent={this} ativo="Menu"></Rodape>
      </section>
    );
  }
}

export default withRouter(AjudaPaginas);
